import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues, change } from 'redux-form';
import { withRouter } from 'react-router';
import v from 'validate.js';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { numberWithCommas, parseNumberWithCommas } from '../../../../../helpers';
import { trackingEvent } from '../../../../../helpers/tracking';
import { onSubmit } from '../../../../../common/components/submit-button';
import RenderInput from '../../../../../common/components/render-input';

export const formDetails = {
    key: 'housing',
    title: 'Monthly Housing',
    formName: Routes.STEPTWO,
    totalKey: 'totalHousing',
    range: {
        high: 40,
        low: 30
    },
    fields: {
        mortgageRent: {
            label: 'Mortgage / Rent'
        },
        propertyTax: {
            label: 'Property Tax'
        },
        homeInsurance: {
            label: 'Home Insurance'
        },
        condoFees: {
            label: 'Condo Fees'
        },
        homeMaintenance: {
            label: 'Home Maintenance'
        },
        utilities: {
            label: 'Utilities'
        },
        other: {
            label: 'Other'
        }
    }
};

const tracking = {
    eventAction: 'Budget Calculator - Step 2',
    eventLabel: 'Housing'
};

const minValue = 0;

const validate = values => v(values,
    Object.keys(formDetails.fields).reduce((obj, val) => ({
        ...obj,
        [val]: {
            numericality: {
                greaterThanOrEqualTo: minValue,
                notGreaterThanOrEqualTo: `must be greater than or equal to $${numberWithCommas(minValue)}`
            }
        }
    }), {})
);

class StepTwoForm extends Component {
    calculateTotal() {
        const {
            props: {
                formValues: {
                    [formDetails.totalKey]: removedTotal,
                    ...values
                }
            }
        } = this;

        return Object.values(values).reduce((total, val) => total + val, 0);
    }

    componentDidUpdate() {
        const {
            props: {
                changeFieldValue
            }
        } = this;

        changeFieldValue(formDetails.totalKey, this.calculateTotal());
    }

    render() {
        return (
            <form className={styles.form}>
                {
                    Object.keys(formDetails.fields).map(key => (
                        <Field
                            key={key}
                            type='text'
                            name={key}
                            label={formDetails.fields[key].label}
                            tooltip={formDetails.fields[key].tooltip}
                            prefix='$'
                            format={numberWithCommas}
                            parse={parseNumberWithCommas}
                            component={RenderInput}
                        />
                    ))
                }
            </form>
        );
    }
}

const formValues = getFormValues(formDetails.formName);

const mapStateToProps = (state) => ({
    formValues: formValues(state),
    paginationSkipState: state.calculator.paginationHasSkip,
});

const mapDispatchToProps = (dispatch) => ({
    changeFieldValue: (field, value) => dispatch(change(formDetails.formName, field, value))
});

StepTwoForm = reduxForm({
    form: formDetails.formName,
    destroyOnUnmount: false,
    validate,
    onSubmit,
    initialValues: Object.keys(formDetails.fields).reduce((obj, val) => ({
        ...obj,
        [val]: minValue
    }), {}),
    redirectPath: `/budget-planner${Routes.STEPTHREE}`,
    skipPath: `/budget-planner${Routes.SUMMARY}`,
    tracking: () => trackingEvent(tracking)
}, mapStateToProps, mapDispatchToProps)(StepTwoForm);

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(StepTwoForm));
